import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=01a9d21f&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
import style0 from "./Contact.vue?vue&type=style&index=0&id=01a9d21f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9d21f",
  null
  
)

export default component.exports